export default __webpack_public_path__ + "static/media/easy-customise.d4fe2213.jpg";